import styles from "./ViewMoreEstimates.module.css";
import React, { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Grid,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  Link,
  KeyboardArrowDown,
  DrawOutlined,
  EditNoteOutlined,
  FileDownloadOutlined,
  DeleteOutlineOutlined,
} from "@mui/icons-material";
const contractValue = [
  { key: "Sub Total", value: "20000.00" },
  { key: "Discount", value: "1000.00" },
  { key: "GST:10%", value: "2000.00" },
  { key: "CGST:10%", value: "2000.00" },
  { key: "VAT:10%", value: "2000.00" },
  { key: "Total", value: "13000.00" },
];
const proposalValue = [
  { key: "Estimate Number", value: "EST#005" },
  { key: "Valid Till", value: "Sat 04 Jan 2025" },
];

const data = {
  description: "salmanan",
  quantity: 1,
  unitPrice: 20000,
  taxes: {
    GST: 10,
    CGST: 18,
    VAT: 10,
  },
  amounts: {
    subTotal: 20000,
    discount: 2000,
    gstAmount: 1800,
    cgstAmount: 3240,
    vatAmount: 1800,
    total: 24840,
  },
};

export default function ViewMoreEstimates() {
  const [anchorEl1, setAnchorEl1] = useState(null);
  const navigate = useNavigate();
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const handleClose = () => {
    navigate("/finance/estimate");
  };
  const handleDownload = () => {
    const element = document.getElementById("contract-section"); // Target the specific section

    if (!element) {
      console.error("Element not found");
      return;
    }

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Define margins
      const margin = 10; // 10mm on each side
      const contentWidth = pdfWidth - 2 * margin; // Adjusted content width
      const contentHeight = (canvas.height * contentWidth) / canvas.width;

      // Add the image with margins
      pdf.addImage(imgData, "PNG", margin, 10, contentWidth, contentHeight);
      pdf.save("estimate-section.pdf");
      handleClose1();
    });
  };
  return (
    <Box sx={{ bgcolor: "#fff", color: "#000" }}>
      <div id="contract-section">
        {/* Header */}
        <div className={styles.top}>
          <img src="/mainfavicon.png" alt="Road Pilot" className={styles.img} />
          <div>CONTRACT</div>
        </div>
        <div className={styles.midFile}>
          <h1>
            <b>
              Road Pilot Pvt. Ltd
              <br /> New Grora, Lucknow, UP
            </b>
          </h1>
          <div className={styles.contractProposal}>
            {proposalValue.map((item) => (
              <div className={styles.keyProposal}>
                <span className={styles.contProposal}>{item.key}</span>{" "}
                <span className={styles.contProposalTwo}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.statusInvoices}>
          <h1>
            <b>Client</b> <br />
            Brayan Gutkowski
            <br />
            Rosenbaum Inc
            <br />
            452 Nikko Parkways Suite 598
            <br />
            North Tyrelshire, MS 84344-1322
          </h1>
          <Button variant="outlined" color="error">
            UNPAID
          </Button>
        </div>

        {/* Table Section */}
        <TableContainer
          component={Paper}
          sx={{
            bgcolor: "#fff",
            color: "#000",
            margin: "0 10px",
            width: "98%",
            border: "1px solid gray",
            borderBottom: "none",
            marginTop: "10px",
            borderRadius: "none",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ bgcolor: "#f0f0f0", color: "#000" }}>
                  Description
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#f0f0f0", color: "#000" }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#f0f0f0", color: "#000" }}
                >
                  Unit Price (USD)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#f0f0f0", color: "#000" }}
                >
                  Tax (%)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#f0f0f0", color: "#000" }}
                >
                  Amount (USD)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ bgcolor: "#fff", color: "#000" }}>
                  {data.description}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#fff", color: "#000" }}
                >
                  {data.quantity}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#fff", color: "#000" }}
                >
                  {data.unitPrice.toLocaleString()}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#fff", color: "#000" }}
                >
                  GST: {data.taxes.GST}%, CGST: {data.taxes.CGST}%, VAT:{" "}
                  {data.taxes.VAT}%
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ bgcolor: "#fff", color: "#000" }}
                >
                  {data.amounts.subTotal.toLocaleString()}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            width: "98%",
            height: "120px",
            border: "1px solid gray",
            borderTop: "none",
            // borderRadius: "3px",
            padding: "10px",
            margin: "0 10px",
          }}
        >
          <div>files comes</div>
          <div>documents</div>
        </Box>
        {/* Summary Section */}
        <Box className={styles.subTotalPosition}>
          <div className={styles.contractFile}>
            {contractValue.map((item) => (
              <div className={styles.keyValue}>
                {" "}
                <span className={styles.contFile}>{item.key}</span>
                <span className={styles.contFileTwo}>{item.value}</span>
              </div>
            ))}
          </div>
        </Box>
        {/* Footer Note */}
        <Box mt={4} pl={1.5} pb={2}>
          <Typography
            variant="body2"
            sx={{ fontSize: "15px", marginBottom: "10px" }}
          >
            <b>Note:</b> Thank you for your business!
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "15px", marginBottom: "10px" }}
          >
            <b>Terms and Conditions:</b> Thank you for your business.
          </Typography>
        </Box>
      </div>
      <hr style={{ color: "gray" }} />
      <Grid container sx={{ padding: "10px 0 20px 10px" }}>
        <Grid item xs={11} className="messageFooter">
          <Box>
            <Button
              id="basic-button"
              aria-controls={open1 ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : undefined}
              onClick={handleClick1}
              className="response"
              endIcon={<KeyboardArrowDown />}
              sx={{
                width: "120%",
                height: "100%",
                color: "#fff",
                bgcolor: "#1d82f5",
                "&:hover": {
                  bgcolor: "orange",
                },
              }}
            >
              Save
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl1}
              open={open1}
              onClose={handleClose1}
              sx={{ zIndex: 3000 }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                value="closed"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {}}
              >
                <Link /> &nbsp; Public Link
              </MenuItem>
              <MenuItem
                value="open"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {}}
              >
                {" "}
                <DrawOutlined /> &nbsp; Company Signature
              </MenuItem>
              <MenuItem
                value="pending"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {}}
              >
                {" "}
                <EditNoteOutlined /> &nbsp; Edit
              </MenuItem>
              <MenuItem
                value="resolved"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleDownload}
              >
                {" "}
                <FileDownloadOutlined /> &nbsp; Download
              </MenuItem>
              <MenuItem
                value="resolved"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {}}
              >
                {" "}
                <DeleteOutlineOutlined /> &nbsp; Delete
              </MenuItem>
            </Menu>
          </Box>
          <Box className="cancel" onClick={handleClose}>
            Cancel
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
